function trimLink(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function parseUrl(value) {
  try {
    return new URL(value);
  } catch (_e) {
    return null;
  }
}

function hashRouteToPath(value) {
  if (value.startsWith('/#/')) return value.slice(2);
  if (value.startsWith('#/')) return value.slice(1);
  return null;
}

function sameOriginRoute(url, origin) {
  const base = (origin || '').replace(/\/$/, '');
  if (!base || url.origin !== base) return null;
  if (url.pathname && url.pathname !== '/') return `${url.pathname}${url.search}`;
  return hashRouteToPath(url.hash) || `${url.pathname}${url.search}${url.hash}` || '/';
}

export function normalizeNotificationRouteTarget(value, origin) {
  const link = trimLink(value);
  if (!link) return null;

  const legacyHashPath = hashRouteToPath(link);
  if (legacyHashPath) return legacyHashPath;

  const url = parseUrl(link);
  if (url) {
    const route = sameOriginRoute(
      url,
      origin || (typeof window !== 'undefined' ? window.location.origin : '')
    );
    if (route) return route;
    const hashPath = hashRouteToPath(url.hash);
    if (hashPath) return hashPath;
    return link;
  }

  return link.startsWith('/') ? link : `/${link}`;
}

export function normalizeNotificationWindowTarget(value, origin) {
  const link = trimLink(value) || '/';
  const url = parseUrl(link);
  const base = (origin || '').replace(/\/$/, '');
  if (url) {
    const route = sameOriginRoute(url, base);
    if (!route) return url.href;
    const path = route.startsWith('/') ? route : `/${route}`;
    return `${base}/#${path}`;
  }

  const route = normalizeNotificationRouteTarget(link) || '/';
  if (!base || /^https?:\/\//.test(route)) return route;

  const path = route.startsWith('/') ? route : `/${route}`;
  return `${base}/#${path}`;
}
